import React, { Component } from 'react';
import * as Config from '../config/Config';
import * as Common from '../helpers/Common';
import * as User from '../helpers/User';

class Chat extends Component {
    constructor(props) {
        super(props);
        this.state={
            ec_id : this.props.params.ec_id,
            time_slot_id : this.props.params.time_slot_id,
        };
    }
    render () {
        let iframestyle={
        display: 'block',
        width: '100vw',
        height: '100vh',
        maxWidth: '100%',
        margin: 0,
        padding: 0,
        border:' 0 none',
        boxSizing:' border-box'
        }
        let learnerID   = btoa(Common.getUserData("id", true));       
        let pinID 		= btoa(Common.getUserData("pinID", true));       
        let productID 	= btoa(Common.getUserData("productID", true));        

        let url=`${Config.rootEcoachChatUrl}index.php?learner_id=${learnerID}&product_id=${productID}&pinID=${pinID}&l=${this.state.ec_id}&c=${this.state.time_slot_id}`;
        return (
            <div>
                <iframe src={url} frameBorder="0" style={iframestyle}></iframe>
            </div>
        )
    }
}

export default Chat


// WEBPACK FOOTER //
// ./src/chat/Chat.js